import { Popover as NbPopover_ } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

export const NbPopover = NbPopover_;

NbPopover.Arrow = addWithConfig(NbPopover_.Arrow);
NbPopover.Body = addWithConfig(NbPopover_.Body);
NbPopover.Content = addWithConfig(NbPopover_.Content);
NbPopover.CloseButton = addWithConfig(NbPopover_.CloseButton);
NbPopover.Header = addWithConfig(NbPopover_.Header);

export default addWithConfig(NbPopover);
